module.exports = "<span ng-show=\"firstPayment\">\r\n   <div>{{'amp.bc3.directives.templates.autopay-summary.next-payment' | translate}} {{firstPayment.amountDue | gwCurrency}}</div>\r\n   <div>{{'amp.bc3.directives.templates.autopay-summary.due' | translate}} {{firstPayment.dueDate | date:'longDate'}}</div>\r\n</span>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/integration/billing/bc3/directives/templates/autopay-summary.html
// module id = 1088
// module chunks = 0